/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RunColorEntityRefDTO
 */
export interface RunColorEntityRefDTO {
    /**
     * sys/name for EXPERIMENT, sys/custom_run_id for RUN
     * @type {string}
     * @memberof RunColorEntityRefDTO
     */
    entityKey: string;
    /**
     * 
     * @type {string}
     * @memberof RunColorEntityRefDTO
     */
    entityType: RunColorEntityRefDTOEntityTypeEnum;
}


/**
 * @export
 */
export const RunColorEntityRefDTOEntityTypeEnum = {
    Experiment: 'EXPERIMENT',
    Run: 'RUN'
} as const;
export type RunColorEntityRefDTOEntityTypeEnum = typeof RunColorEntityRefDTOEntityTypeEnum[keyof typeof RunColorEntityRefDTOEntityTypeEnum];


/**
 * Check if a given object implements the RunColorEntityRefDTO interface.
 */
export function instanceOfRunColorEntityRefDTO(value: object): value is RunColorEntityRefDTO {
    if (!('entityKey' in value) || value['entityKey'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    return true;
}

export function RunColorEntityRefDTOFromJSON(json: any): RunColorEntityRefDTO {
    return RunColorEntityRefDTOFromJSONTyped(json, false);
}

export function RunColorEntityRefDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunColorEntityRefDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'entityKey': json['entityKey'],
        'entityType': json['entityType'],
    };
}

export function RunColorEntityRefDTOToJSON(value?: RunColorEntityRefDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'entityKey': value['entityKey'],
        'entityType': value['entityType'],
    };
}

